/**
 * EmployeeTemplate
 */

import React from 'react';
import PropTypes from 'prop-types';
import useLocaleContext from 'containers/LanguageProvider/useLocaleContext.js';
import Page from './Page.jsx';
import HowToUse from './HowToUse.jsx';

function EmployeeTemplate(props) {
  const { locale } = useLocaleContext();
  const { users, language = locale } = props;

  const pages = users.map((user) => language === 'nl' ? (
    <Page header greeting footer key={user.code}>
      <p>Beste collega,</p>
      <p>Hieronder vind je de activeringscode die je nodig hebt om gebruik te kunnen maken van Social Schools. Deze code is persoonlijk en je koppelt deze aan je Social Schools account.</p>
      <ul className="list-unstyled mt-3 mb-4 ps-5">
        <li className="my-2">
          <span className="def-label">Naam:</span>
          {user.name}
        </li>
        <li className="my-2 fw-semibold">
          <span className="def-label">Koppelcode:</span>
          <samp>{user.code}</samp>
        </li>
      </ul>
      <HowToUse locale="nl" />
    </Page>
  ) : (
    <Page header greeting footer key={user.code}>
      <p>Dear colleague,</p>
      <p>Please find below the code that you need to connect to Social Schools. This code is personal and you have to add this to your Social Schools account.</p>
      <ul className="list-unstyled mt-3 mb-4 ms-5">
        <li className="my-2">
          <span className="def-label">Name:</span>
          {user.name}
        </li>
        <li className="my-2 fw-semibold">
          <span className="def-label">Connection Code:</span>
          <samp>{user.code}</samp>
        </li>
      </ul>
      <HowToUse locale="en"/>
    </Page>
  ));
  return pages;
}

EmployeeTemplate.propTypes = {
  users: PropTypes.array,
};

export default EmployeeTemplate;
